import s from './Sticker.module.scss'

type StickerProps = {
  children: React.ReactNode
  className?: string
  clickable?: boolean
  bgColor?: string
  trafficSign?: boolean
}

export function Sticker({
  children,
  className = '',
  clickable = false,
  bgColor = 'bright',
  trafficSign = false,
}: StickerProps) {
  const classes = [s.sticker]
  if (clickable) classes.push(s.clickable)
  if (trafficSign) classes.push(s.trafficSign)
  if (className) classes.push(className)

  return (
    <span className={classes.join(' ')} data-color={bgColor}>
      {children}
    </span>
  )
}
